module.exports = __webpack_public_path__ + "static/media/PhilippaAshcroft.ffcb5030.jpg";